import React from "react";
import { Image } from "antd";
import InfoLogo from "../../icons/svg/ExclamationCircleOutlined.svg";

const MetricInfoLogo = ({ onClick, className = "text-black/[0.45] text-sm" }) => {
  return (
    <Image
      preview={false}
      src={InfoLogo}
      className={className}
      style={{ cursor: "pointer" }}
      onClick={onClick}
    />
  );
};

export default MetricInfoLogo;
